// extracted by mini-css-extract-plugin
module.exports = {"button":"Header_button__2M-9a","ar-canvas":"Header_ar-canvas__2VFHa","instModal":"Header_instModal__3QP7r","active":"Header_active__3GX0s","header":"Header_header__1v0yI"};